import { IGetIndicadoresServicosObrasUseCase } from "../../../presentation/useCases/read/get_indicadores_servicos_obras_use_case";
import { IndicadoresServicosObra } from "../../models/indicadores_servicos_obra";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetIndicadoresServicosObrasUseCase
 */

export class GetIndicadoresServicosObrasUseCase implements IGetIndicadoresServicosObrasUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getIndicadoresServicosObras(
    idObra: number | undefined,
  ): Promise<IndicadoresServicosObra> {
    if (idObra === undefined) throw new Error('O id da obra não pode ser indefinido!');
    return await this.repository.getIndicadoresServicosObras(idObra);
  }
}
